import type {
  ModulationOperationSchema,
  ModulationOperationsPathParams,
  UpdateModulationOperationPayload
} from '@libs/data-access/entities'

import { httpServices } from '../../../../apis'
import type { QueryFnParams } from '../../../../types'

export type FetchModulationUserContractOperationsOptions = QueryFnParams<{
  pathParams: {
    modulation_user_contract_id: number
  }
}>
/**
 * Fetch all operations for a given modulation user contract
 */
export const fetchModulationUserContractOperations = async (
  opts?: FetchModulationUserContractOperationsOptions
) => {
  const response = await httpServices.core.get<ModulationOperationSchema[]>(
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    `/modulation_user_contracts/${opts.pathParams.modulation_user_contract_id}/modulation_operations`
  )
  return response.data
}

export type UpdateModulationUserContractOperationOptions = QueryFnParams<{
  payload: UpdateModulationOperationPayload
  pathParams: ModulationOperationsPathParams
}>
/**
 * Update an operation for a given modulation user contract
 */
export const updateModulationUserContractOperation = async (
  opts?: UpdateModulationUserContractOperationOptions
) => {
  const response = await httpServices.core.put<ModulationOperationSchema>(
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    `/modulation_user_contracts/${opts.pathParams.modulation_user_contract_id}/modulation_operations/${opts.pathParams.week}`,
    opts?.payload
  )
  return response.data
}

export type DeleteModulationUserContractOperationOptions = QueryFnParams<{
  pathParams: ModulationOperationsPathParams
}>
/**
 * Delete an operation for a given modulation user contract
 */
export const deleteModulationUserContractOperation = async (
  opts?: DeleteModulationUserContractOperationOptions
) => {
  const response = await httpServices.core.delete(
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    `/modulation_user_contracts/${opts.pathParams.modulation_user_contract_id}/modulation_operations/${opts.pathParams.week}`
  )
  return response.data
}
